import { Item } from '@react-stately/collections';
import { ItemProps } from '@react-types/shared';
import { ReactNode } from 'react';

export interface InteractiveListItemProps<T>
  extends Omit<ItemProps<T>, 'children'> {
  contentLeft: ReactNode;
  contentRight?: ReactNode;
}

const InteractiveListItem = Item as unknown as <T>(
  props: InteractiveListItemProps<T>
) => JSX.Element;

export { InteractiveListItem };
